import { render } from "./ViewFaqPage.vue?vue&type=template&id=7d25325e&ts=true"
import script from "./ViewFaqPage.vue?vue&type=script&lang=ts"
export * from "./ViewFaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__